import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import CommonCardHeader from "../CommonComponents/CommonCardHeader/CommonCardHeader";
import CandidateTable from "../DataTables/Candidates/CandidatesTable";

const CandidateRecordContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Candidates" parent="Recruitment" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CandidateTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CandidateRecordContainer;
